import { components } from "./openapiSchema";

export const enum ProductUrls {
  Postcode = "/",
  OffStreetParking = "/off-street-parking",
  KerboCharge = "/kerbo-charge",
  ChargerCustomisation = "/charger-customisation",
  Login = "/login",
  PersonalDetails = "/details",
  PersonalDetailsConfirm = "/personal-details-confirm",
  ConfirmEmail = "/confirm-email",
  EmailConfirmation = "/email-confirmed",
  Payment = "/payment-details",
  ErrorPage = "/error",
  Expired = "/quote-expired",
  QuoteRequoted = "/quote-requoted",
}

export const enum ErrorMessages {
  REQUIRED = "This field is required.",
  SELECT_REQUIRED = "Select an answer.",
  INVALID_POSTCODE = "Invalid postcode.",
  SELECT_CONNECTION = "Select connection type",
  SELECT_CABLE_SETUP = "Select cable setup",
  SELECT_CABLE_LENGTH = "Select cable length",
  SELECT_CHARGER_COLOUR = "Select base colour",
  INVALID_VALUE = "Invalid value.",
  EMAIL_NOT_SAME = "Emails should be same.",
  ENTER_FIRST_NAME = "Enter your first name",
  ENTER_LAST_NAME = "Enter your last name",
  ENTER_EMAIL = "Enter your email.",
  ENTER_NEW_EMAIL = "Email should not be the same as your current.",
  INVALID_EMAIL_FORMAT = "Email should be in the format name@example.com",
  ENTER_PHONE_NUMBER = "Enter your mobile number.",
  INVALID_PHONE_NUMBER = "The mobile number should start with 07 and be 11 digits long.",
  CONFIRM_PHONE_NUMBER = "Confirm your mobile number.",
  PHONE_NUMBER_DOES_NOT_MATCH = "Make sure these mobile numbers match.",
  YOU_MUST_AGREE = "You must agree to share your contact details",
}

export enum Charger {
  INDRA = "indra",
  HYPERVOLT = "hypervolt",
  ANDERSENA2 = "andersen-a2",
  ANDERSENA3 = "andersen-a3",
  ANDERSENQUARTZ = "andersen-quartz",
  ZAPPI21 = "zappi-2.1",
  ZAPPIGLOW = "zappi-glo",
}

export enum CustomisableCharger {
  INDRA = "indra",
  HYPERVOLT = "hypervolt",
  ANDERSENA2 = "andersen-a2",
  ANDERSENA3 = "andersen-a3",
  ANDERSENQUARTZ = "andersen-quartz",
  ZAPPI21 = "zappi-2.1",
}

export const enum CableSetup {
  TETHERED = "tethered",
  UNTETHERED = "untethered",
}

export enum PaymentTypes {
  CARD = "Card",
}

export enum ErrorTypes {
  ALREADY_SUBMITTED = "submitted",
  ALREADY_VERIFIED = "verified",
  EXPIRED = "expired",
  LEAD_DELETED = "deleted",
  OOPS = "oops",
  MAINTENANCE = "maintenance",
  SORRY_THERE_WAS_A_PROBLEM = "Sorry, there was a problem",
  WE_CANT_FIND_ORDER = "We can't find order",
}

type validChargerUuids =
  components["schemas"]["register-interest-request"]["chargerId"];

export const ValidChargerIds: Record<string, validChargerUuids> = {
  Indra_Smart_PRO_Tethered: "bd86e58e-5df7-4c7a-a65b-5d7044dd0322",
  Indra_Smart_PRO_Not_Tethered: "04d1c014-9881-4c04-9cdf-15a1ba484cd1",
  Hypervolt_Tethered: "bedb5c20-fe68-49b4-961a-1d0ebd06c906",
  Andersen_A2: "751ed51c-7e3a-4377-9157-22338625f03f",
  Andersen_A3: "7bc98527-52cb-40ad-a7be-105a2c90c183",
  Andersen_Quartz: "d65a6cf3-e788-491b-a799-fe0810529925",
  Zappi_GLO: "e2947a1b-1c01-4e38-85aa-82307ca46d14",
  Zappi_21: "3454118c-5578-4297-aa10-2d7ad29448e9",
};
